const BaseModule = require('../../../../90_utils/base/BaseModule');

class ScrollOverlaySlides extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$photoBlock = this.$el.find('.photo-block');
		this.$textBlock = this.$el.find('.text-block');
		this.$slidesWrapper = this.$el.find('.slides-wrapper');
		this.$photoSlides = this.$el.find('.photo-slides >li');
		this.$textSlides = this.$el.find('.text-slides >li');
		this.$textSlidesInner = this.$textSlides.find('.inner-wrapper');
		this.$textSlide;
		this.$textSlideInner;
		this.$window = $(window);

		this.slidesTotal = this.$el.find('.text-slides >li').length;
		this.slideIndex = -1;
		this.transitionDelays = [];
		this.isIns = [];

		this.bounds;
		this.isMobile = false;
		this.isTrans = false;
	}

	// basemodule methods

	_domReady(){

		for(let i=0; i<this.$textSlides.length; i++){

			let $textSlide = this.$textSlides.eq(i);
			let $expandedContent = $textSlide.find('.expanded-content');

			$expandedContent.css('height', 0);

			// enable modals from read more (weird)

			let $readMore = $textSlide.find('.read-more-goop .goop-button');
			let modalId = $textSlide.attr('data-modal-id') ? '#modal--' + $textSlide.attr('data-modal-id') : '';

			if(modalId){
				$readMore.attr('data-modaal-href', modalId);
				$readMore.modaal();
			}
		}

		this._resize();
	}

	_addListeners(){

		this.$el.find('.read-more-goop .goop-button').on('click', $.proxy(this._onReadMoreClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));
		this.$window.on('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.on('modalOpen', this._onModalOpen, this);
		window.vent.on('modalClose', this._onModalClose, this);
	}

	_removeListeners(){

		this.$el.find('.read-more-goop .goop-button').off('click', $.proxy(this._onReadMoreClick, this));

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$window.off('mousewheel', $.proxy(this._onMouseWheel, this));

		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);
	}

	// listener methods

	_onReadMoreClick(e){

		let $target = $(e.currentTarget);
		let $textSlide = $target.closest('.text-slide');

		if(!$target.attr('data-modaal-href')){
			this._toggleExpanded($textSlide);
		}
	}

	_onMouseWheel(e){
		this._checkScroll(this.$window.scrollTop() - e.deltaY, true);
	}

	_onScroll(e){
		this._checkScroll(this.$window.scrollTop());
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	// toggle expanded content

	_toggleExpanded($textSlide){

		this.$textSlides.each((index, value) => {
			let $value = $(value);
			if($textSlide[0] === $value[0]){
				$value.toggleClass('is-expanded');
			}
			else {
				// $value.removeClass('is-expanded');
			}
		});

		this._checkSizes(0.3, $textSlide);
	}

	//

	_checkSizes(animationTime, $triggerSlide){

		animationTime = typeof(animationTime) === 'undefined' ? 0 : animationTime;

		for(let i=0; i<this.$textSlides.length; i++){

			let $textSlide = this.$textSlides.eq(i);
			let $scrollArea = this.$el.find('.scroll-area li').eq(i);
			let $photoSlide = this.$el.find('.photo-slide').eq(i);

			let $innerWrapper = $textSlide.find('.inner-wrapper');
			let $textContent = $textSlide.find('.text-content');
			let $description = $textSlide.find('.description');
			let $expandedContent = $textSlide.find('.expanded-content');

			TweenMax.killTweensOf([$innerWrapper, $textSlide, $scrollArea, $photoSlide], {height:true});

			if($textSlide.hasClass('is-expanded')){

				if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

					if(animationTime === 0){

						TweenMax.set([$innerWrapper, $scrollArea, $textSlide, $expandedContent], {clearProps:'top, height'});

						if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){

							let wrapperHeightFrom = $innerWrapper.outerHeight();
							let wrapperHeightTo = $textContent.outerHeight() + 160;
							TweenMax.set($innerWrapper, {y:Math.round((wrapperHeightFrom - wrapperHeightTo)/2), opacity:1, height: wrapperHeightTo});

							if(wrapperHeightTo > $scrollArea.outerHeight() - 80){
								TweenMax.set([$textSlide, $scrollArea], {height: wrapperHeightTo + 80});
							}
						}
					}
					else {

						TweenMax.set([$innerWrapper, $scrollArea, $textSlide, $expandedContent], {clearProps:'top, height'});

						if($textContent.outerHeight() >= $innerWrapper.outerHeight() - 160){

							let wrapperHeightFrom = $innerWrapper.outerHeight();
							let wrapperHeightTo = $textContent.outerHeight() + 160;
							let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

							this.isTrans = true;

							TweenMax.set($innerWrapper, {y:0, height:wrapperHeightFrom});
							TweenMax.to($innerWrapper, animationTime, {y:ySlide, opacity:1, height: wrapperHeightTo, ease:'scrollEase', onComplete:() => {
								this._resize(true);
							}});

							if(wrapperHeightTo > $scrollArea.outerHeight() - 80){
								TweenMax.to([$textSlide, $scrollArea], animationTime, {height: wrapperHeightTo + 80, ease:'scrollEase', onComplete:() => {
									this._resize(true);
								}});
							}

							if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
								// window.vent.trigger('scrollTo', {scrollTop: this.$window.scrollTop() + ySlide, animationTime: animationTime});
							}
						}
					}
				}
				else {

					let wrapperHeightFrom = $innerWrapper.outerHeight();
					TweenMax.set([$expandedContent], {clearProps:'height'});
					let wrapperHeightTo = $textContent.outerHeight();
					let wrapperY = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);
					let containerHeight = $textContent.outerHeight();

					// need to resize outer box?

					if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){

						TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
							this._resize(true);
						}});
					}

					TweenMax.to($innerWrapper, animationTime, {opacity:1, y: wrapperY, height: wrapperHeightTo, ease:Cubic.easeOut});
				}

				// animate expanding field... expanding

				if(animationTime === 0){
					TweenMax.set([$expandedContent], {clearProps:'height', opacity:1});
					this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
				}
				else {

					if(parseFloat($expandedContent.css('opacity')) === 0){

						TweenMax.fromTo($expandedContent, animationTime, {opacity:0, height: 0},
							{opacity:1, height: $expandedContent.outerHeight(), ease:Cubic.easeOut, onUpdate:() => {
								this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
								this._onScroll();
							}});
					}
				}
			}
			else {

				let expandedContentHeight = $expandedContent.outerHeight();
				TweenMax.set($expandedContent, {height:0});

				// collapsing expanded text

				if(animationTime === 0){

					TweenMax.set([$innerWrapper, $textSlide, $photoSlide, $scrollArea], {clearProps: 'all'});
					let wrapperHeightTo = $textContent.outerHeight();

					// need to resize outer box?

					if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){
						TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
							this._resize(true);
						}});
					}
				}
				else {

					// inner wrapper

					let wrapperHeightFrom = $innerWrapper.outerHeight();
					TweenMax.set($innerWrapper, {clearProps:'height'});

					let wrapperHeightTo = $innerWrapper.outerHeight();
					$innerWrapper.css('height', wrapperHeightFrom);

					// text height

					let textHeightFrom = $textSlide.outerHeight();
					TweenMax.set($textSlide, {clearProps:'height'});

					let textHeightTo = $textSlide.outerHeight();
					$textSlide.css('height', textHeightFrom);

					// text height

					let photoHeightFrom = $photoSlide.outerHeight();
					TweenMax.set($photoSlide, {clearProps:'height'});

					let photoHeightTo = $photoSlide.outerHeight();
					$photoSlide.css('height', photoHeightFrom);

					// scroll height

					let scrollHeightFrom = $scrollArea.outerHeight();
					TweenMax.set($scrollArea, {clearProps:'height'});

					let scrollHeightTo = $scrollArea.outerHeight();
					$scrollArea.css('height', scrollHeightFrom);

					// correct wrapper

					if(window.SETTINGS.breakpoint.minWidth('screen-medium')){

						let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

						this.isTrans = true;

						TweenMax.to($innerWrapper, animationTime, {y:0, height: wrapperHeightTo, ease:'scrollEase'});
						TweenMax.to($textSlide, animationTime, {y:0, height: textHeightTo, ease:'scrollEase'});
						TweenMax.to($scrollArea, animationTime, {y:0, height: scrollHeightTo, ease:'scrollEase'});
						TweenMax.set([$photoSlide], {clearProps: 'all'});

						if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
							window.vent.trigger('scrollTo', {scrollTop: $textSlide.offset().top + ySlide - 80, animationTime: animationTime});
						}
					}
					else {

						TweenMax.set([$innerWrapper, $textSlide, $photoSlide, $scrollArea], {clearProps: 'all'});
						let wrapperHeightTo = $textContent.outerHeight();
						let ySlide = Math.round((wrapperHeightFrom - wrapperHeightTo)/2);

						// need to resize outer box?

						if(wrapperHeightTo > window.SETTINGS.coords.winHeight - 160){
							TweenMax.to([$scrollArea, $textSlide, $photoSlide], animationTime, {height: wrapperHeightTo + 160, ease:Cubic.easeOut, onComplete:() => {
								this._resize(true);
							}});
						}

						if($triggerSlide && $triggerSlide[0] === $textSlide[0]){
							window.vent.trigger('scrollTo', {scrollTop: $textSlide.offset().top + ySlide - 80, animationTime: animationTime});
						}
					}
				}

				// animate expanding field... SHRINKING

				if(animationTime === 0){
					TweenMax.set([$expandedContent], {opacity:0, height:0});
					this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
				}
				else {

					TweenMax.set($expandedContent, {height:expandedContentHeight});
					TweenMax.to($expandedContent, animationTime, {opacity:0, height: 0, ease:'scrollEase', onUpdate:() => {
						this.isTrans = false;
						this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
						this._onScroll();
					}});
				}
			}
		}

		this._resize(true);
	}

	//

	_checkScroll(scrollTop, isFromScrollWheel){

		let newSlideIndex = this.slideIndex;
		let winHeight = window.SETTINGS.coords.winHeight;

		if(!this.isModalOpen && !this.isMobile && !this.isTrans){

			if(scrollTop >= this.bounds.top){

				if(scrollTop + winHeight < this.bounds.bottom){

					this.$slidesWrapper.addClass('is-fixed');
					this.$slidesWrapper.removeClass('bottomed');

					let innerScroll = scrollTop - this.bounds.top - winHeight/2;
					newSlideIndex = Math.round((innerScroll + winHeight/3) / (winHeight * 1.33));
					newSlideIndex = Math.min(this.slidesTotal-1, newSlideIndex);
				}
				else {
					this.$slidesWrapper.removeClass('is-fixed');
					this.$slidesWrapper.addClass('bottomed');
					newSlideIndex = this.slidesTotal-1;
				}
			}
			else {
				this.$slidesWrapper.removeClass('is-fixed bottomed');
				newSlideIndex = 0;
			}

			if(newSlideIndex !== this.slideIndex){
				this._swapContentByIndex(newSlideIndex);
			}

			// add center class if selected slide is visible

			if(this.$textSlideInner && this.$textSlideInner.length) {

				let textBounds = window.utils.PositioningUtils.getScrollOffset(this.$textSlideInner);

				if(textBounds.bottom < winHeight - winHeight * 0.05 && textBounds.bottom > winHeight * 0.15){
					this.$textSlide.addClass('is-centered');
				}
				else {
					this.$textSlide.removeClass('is-centered');
				}
			}
		}
		else if(this.isMobile){

			this.$textSlides.each((index, value) => {

				let $textSlideInner = $(value).find('> .inner-wrapper');

				let scrollTop = this.$window.scrollTop();
				let bounds = window.utils.PositioningUtils.getScrollOffset($textSlideInner);

				if((bounds.top < winHeight/2) || (bounds.height < winHeight && bounds.bottom < winHeight)){
					if((bounds.top < winHeight/3) || (bounds.height < winHeight && bounds.bottom <= winHeight)){
						if(!$textSlideInner.hasClass('is-in')){
							$textSlideInner.removeClass('is-in-slow');
							$textSlideInner.addClass('is-in');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 50);
						}
					}
					else {
						if(!$textSlideInner.hasClass('is-in-slow')){
							$textSlideInner.removeClass('is-in');
							$textSlideInner.addClass('is-in-slow');
							this.isIns[index] = true;

							if(this.transitionDelays[index]){
								window.clearTimeout(this.transitionDelays[index]);
							}
							this.transitionDelays[index] = window.setTimeout(() => {
								$textSlideInner.addClass('is-in-showing');
								this.transitionDelays[index] = null;
							}, 400);
						}
					}
				}
				else if(bounds.bottom < winHeight/4
					|| bounds.top > winHeight/4*3){

					if(this.isIns[index]){
						$textSlideInner.removeClass('is-in is-in-slow is-in-showing');
						this.isIns[index] = false;

						if(this.transitionDelays[index]){
							window.clearTimeout(this.transitionDelays[index]);
							this.transitionDelays[index] = null;
						}
					}
				}
			});
		}
	}

	//

	_swapContentByIndex(newSlideIndex){

		if(newSlideIndex !== this.slideIndex){

			let $oldPhoto = (this.slideIndex >= 0) ? this.$photoSlides.eq(this.slideIndex) : null;
			if($oldPhoto){ $oldPhoto.css('opacity', 1); }

			this.slideIndex = newSlideIndex;

			TweenMax.fromTo(this.$photoSlides.eq(this.slideIndex), 0.3, {opacity:0}, {opacity:1, ease:'fade', onComplete:() => {
				if($oldPhoto){ $oldPhoto.css('opacity', ''); }
			}});

			this.$photoSlides.removeClass('is-active');
			this.$photoSlides.eq(this.slideIndex).addClass('is-active');

			this.$textSlides.removeClass('is-active');
			this.$textSlide = this.$textSlides.eq(this.slideIndex).addClass('is-active');

			this.$textSlideInner = this.$textSlidesInner.eq(this.slideIndex);

			if(!this.$textSlide.length || !this.$textSlideInner.length){
				this.$textSlide = this.$textSlides.addClass('is-active');
				this.$textSlideInner = this.$textSlidesInner;
			}
		}
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){
	}
	_resize(dontCheckSizes){

		this.isMobile = window.SETTINGS.breakpoint.maxWidth('screen-medium');

		if(this.isMobile){
			this.$el.find('.is-fixed').removeClass('is-fixed');
		}

		this.bounds = window.utils.PositioningUtils.getExtendedOffset(this.$el);
		if(dontCheckSizes !== true){ this._checkSizes(0); }
		this._checkScroll(this.$window.scrollTop());
	}
}

module.exports = ScrollOverlaySlides;
